import useGet from "../useGet";

const useUser = (
  companyId: string | undefined,
  userId: number | undefined,
  dependencies?: any[]
) => {
  const { value, loading } = useGet(
    `/api/Companies/${companyId}/Users/${userId}?ts=` + new Date().getTime(),
    `Unable to read user '${userId}' for company id '${companyId}'`,
    null,
    dependencies ? [...dependencies, companyId, userId] : [companyId, userId],
    undefined,
    () => companyId != undefined && companyId !== "" && userId != null
  );

  return {
    user: value,
    userLoading: loading
  };
};

export default useUser;
